import { Component, ViewChild } from '@angular/core';
import { NavController, Searchbar } from 'ionic-angular';
import { DataProvider, sort } from '../../providers/data/data';
import { CombinedResultsPage } from '../combined-results/combined-results';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { IoDiagnosis, IoDrug, IoDrugGroup, IoDrugSubstance, DrugSubstance } from '../../types';
import { DrugDetailPage } from '../drug-detail/drug-detail';
import { DrugCategoryPage } from '../drug-category/drug-category';
import { DrugFilterSettings, FilterSettingsComponent } from '../../components/filter-settings/filter-settings';
import { SettingsProvider } from '../../providers/settings/settings';
import { AdvancedSearchPage } from '../advanced-search/advanced-search';
import { DrugDataStore } from '../../providers/data/drug-data-store';
import { ImpressumPage } from '../impressum/impressum';
import { AboutPage } from '../about/about';

const maxDefaultSearchResultCount = 20;

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  prefilter: 'diagnoses' | 'drugs' | 'groups' = 'diagnoses';
  showAllTimeout: number | undefined;
  filterSettings: DrugFilterSettings = { showTrademarks: true };
  isDataLoaded = false;
  hideAdvancedSearch = false;

  @ViewChild('searchbar') searchbar: Searchbar;

  constructor(
    public navCtrl: NavController,
    private dataProvider: DataProvider,
    private dds: DrugDataStore,
    private analytics: AnalyticsProvider,
    settingsProvider: SettingsProvider) {

    const simplify = window.location.search.indexOf("simplify") >= 0;
    if (simplify) {
      this.hideAdvancedSearch = true;
      settingsProvider.setLocalBool(FilterSettingsComponent.showTrademarksSettingsKey, true);
    }

    const showTrademarksRemembered = settingsProvider.getLocalBool(FilterSettingsComponent.showTrademarksSettingsKey);
    if (showTrademarksRemembered !== null) {
      this.filterSettings.showTrademarks = showTrademarksRemembered;
    }
  }

  diagnoses: Array<IoDiagnosis> = [];
  diagnosesAllResults: Array<IoDiagnosis> = [];
  drugs: Array<IoDrug> = [];
  drugsAllResults: Array<IoDrug> = [];
  substances: Array<IoDrugSubstance> = [];
  substancesAllResults: Array<IoDrugSubstance> = [];
  groups: Array<IoDrugGroup> = [];
  groupsAllResults: Array<IoDrugGroup> = [];

  onPrefilterChange(value: string) {
    this.analytics.emitEvent('home', 'prefilter', value);
  }

  filterItems() {
    if (!this.isDataLoaded) {
      return;
    }

    let val = this.searchbar.value.trim();

    this.analytics.emitEvent('home', 'searchInputLength', val.length + '');

    this.diagnosesAllResults = this.dataProvider.searchDiagnosis(val);
    sort(this.diagnosesAllResults);
    this.diagnoses = this.diagnosesAllResults.slice(0, maxDefaultSearchResultCount);
    
    this.drugsAllResults = this.dataProvider.searchDrugs(val);
    sort(this.drugsAllResults);
    this.drugs = this.drugsAllResults.slice(0, maxDefaultSearchResultCount);

    this.substancesAllResults = <Array<IoDrugSubstance>>this.drugsAllResults.filter(d => !d.isTrademark);
    this.substances = this.substancesAllResults.slice(0, maxDefaultSearchResultCount);

    this.groupsAllResults = this.dataProvider.searchGroups(val);
    sort(this.groupsAllResults);
    this.groups = this.groupsAllResults.slice(0, maxDefaultSearchResultCount);

    window.clearTimeout(this.showAllTimeout);
    this.showAllTimeout = window.setTimeout(() => {
      this.groups = this.groupsAllResults;
      this.drugs = this.drugsAllResults;
      this.substances = this.substancesAllResults;
      this.diagnoses = this.diagnosesAllResults;
      this.dds.calculateEffectStatsWhereMissing(this.drugs);
    }, 1000)
  }

  diagnosisClicked(diagnosis: IoDiagnosis) {
    this.analytics.emitEvent('home', 'diagnosisSelected');
    this.navCtrl.push(CombinedResultsPage, diagnosis);
  }

  drugClicked(drug: IoDrug) {
    this.analytics.emitEvent('home', 'drugSelected');
    this.navCtrl.push(DrugDetailPage, [drug]);
  }

  groupClicked(group: IoDrugGroup) {
    this.analytics.emitEvent('home', 'groupSelected');
    this.navCtrl.push(DrugCategoryPage, [group]);
  }

  navigateToAdvancedSearch() {
    this.navCtrl.push(AdvancedSearchPage);
  }

  gotoImpressum() {
    this.navCtrl.push(ImpressumPage);
  }

  gotoAbout() {
    this.navCtrl.push(AboutPage);
  }

  handleSettingsChanged(settings: DrugFilterSettings) {
    this.filterSettings = settings;
    this.filterItems();
  }

  ionViewDidLoad() {
    this.dataProvider.loadAndInitializeData().subscribe(() => {
      this.isDataLoaded = true;
      this.searchbar.setFocus();
      if (this.searchbar.value.trim()) {
        this.filterItems();
      }
    });
  }

  ionViewDidEnter() {
    if (this.searchbar._elementRef.nativeElement !== window.document.activeElement) {
      setTimeout(() => {
        this.searchbar.setFocus();
      }, 150);
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts